import React from 'react';
import { SpadeSuit, DiamondSuit, ClubSuit, HeartSuit } from './Suit';

function Card({ rotate, x, y, color, Suit, label }) {
  return (
    <div
      className="absolute w-[86px] h-[124px] rounded-xl bg-white flex flex-col justify-between p-2"
      style={{
        transform: `translate(${x}px, ${y}px) rotate(${rotate}deg)`,
        border: '1.5px solid #1a1a1a',
        boxShadow: '0 10px 24px rgba(0,0,0,0.35), 0 2px 6px rgba(0,0,0,0.2)',
      }}
    >
      <div className="flex items-center gap-0.5 leading-none" style={{ color }}>
        <span className="font-black text-base">{label}</span>
        <Suit size={14} />
      </div>
      <div className="flex justify-center items-center flex-1" style={{ color }}>
        <Suit size={40} />
      </div>
      <div className="flex items-center gap-0.5 self-end leading-none rotate-180" style={{ color }}>
        <span className="font-black text-base">{label}</span>
        <Suit size={14} />
      </div>
    </div>
  );
}

export default function PlayingCardLogo() {
  return (
    <div className="relative w-[260px] h-[160px] mx-auto">
      <Card rotate={-22} x={0}   y={14} color="#0d0d0d" Suit={SpadeSuit}  label="H" />
      <Card rotate={-7}  x={55}  y={2}  color="#c92a2a" Suit={HeartSuit}  label="O" />
      <Card rotate={9}   x={115} y={2}  color="#c92a2a" Suit={DiamondSuit} label="C" />
      <Card rotate={22}  x={170} y={14} color="#0d0d0d" Suit={ClubSuit}   label="♣" />
    </div>
  );
}
